var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_149852",
    clipPath: "url(#clip0_3735_1075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6546 13.0994L10.3226 9.63397C11.1793 8.61554 11.6487 7.33414 11.6487 6.00015C11.6487 2.88341 9.11298 0.347656 5.99624 0.347656C2.87951 0.347656 0.34375 2.88341 0.34375 6.00015C0.34375 9.11689 2.87951 11.6526 5.99624 11.6526C7.16631 11.6526 8.28133 11.2997 9.23463 10.6298L12.592 14.1216C12.7323 14.2673 12.921 14.3477 13.1233 14.3477C13.3148 14.3477 13.4964 14.2747 13.6342 14.142C13.9272 13.8601 13.9365 13.3926 13.6546 13.0994ZM5.99624 1.82222C8.3 1.82222 10.1742 3.69639 10.1742 6.00015C10.1742 8.30391 8.3 10.1781 5.99624 10.1781C3.69248 10.1781 1.81831 8.30391 1.81831 6.00015C1.81831 3.69639 3.69248 1.82222 5.99624 1.82222Z",
    fill: "#4398FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3735_1075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.101562 0.347656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2a744b20821d8346cc1c4cff866385e1.svg";
export { ForwardRef as ReactComponent };